var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c("div", { staticClass: "contents_wrap" }, [
      _c("h2", { staticClass: "pg_title" }, [
        _vm._v("Mobile SVC Request Status Detail (Other)")
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "sub_tit" }, [_vm._v("Basic")]),
      _vm._v(" "),
      _c("table", { staticClass: "create_table" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("th", [_vm._v("Name")]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.name))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v("English Name")]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.engName))])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn_wrap topLine" }),
      _vm._v(" "),
      _c("div", { staticClass: "sub_tit mt40" }, [
        _vm._v("Request Information")
      ]),
      _vm._v(" "),
      _c("table", { staticClass: "create_table" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("th", [_vm._v("Request Type")]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.reqType))])
          ]),
          _vm._v(" "),
          ["003", "004"].includes(_vm.reqTypeCode)
            ? _c("tr", [
                _c("th", [_vm._v("ESN/IMEI Writing P/W")]),
                _vm._v(" "),
                _c("td", [_vm._v("******************")])
              ])
            : _vm._e(),
          _vm._v(" "),
          ["006", "007"].includes(_vm.reqTypeCode)
            ? _c("tr", [
                _c("th", [_vm._v("Country")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.country))])
              ])
            : _vm._e(),
          _vm._v(" "),
          ["008"].includes(_vm.reqTypeCode)
            ? _c("tr", [
                _c("th", [_vm._v("User Role")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.role))])
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn_wrap topLine" }, [
        _c(
          "a",
          { staticClass: "btn_white", on: { click: _vm.onListBtnClick } },
          [_vm._v("List")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bc_ico" }, [
      _vm._v("\n            Home\n            "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v("Engineer\n            "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v("Mobile SVC\n            "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v("Mobile SVC Request Status Detail (Other)\n        ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-86338e84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86338e84","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/anysvcmobile/request/RequestOtherView.vue
// module id = fpm2
// module chunks = 0